import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AdminCard = ({ card }) => {
  const { t } = useTranslation();

  // Color mapping for different card types using CSS variables
  const getColorStyles = (color) => {
    const colorMap = {
      primary: {
        backgroundColor: "var(--bs-primary)",
        textColor: "var(--bs-primary)",
        bgLight: "rgba(238, 82, 60, 0.1)",
      },
      success: {
        backgroundColor: "var(--bs-success)",
        textColor: "var(--bs-success)",
        bgLight: "rgba(49, 166, 30, 0.1)",
      },
      warning: {
        backgroundColor: "var(--bs-warning)",
        textColor: "var(--bs-warning)",
        bgLight: "rgba(251, 187, 33, 0.1)",
      },
      blue: {
        backgroundColor: "var(--bs-blue)",
        textColor: "var(--bs-blue)",
        bgLight: "rgba(66, 133, 244, 0.1)",
      },
      orange: {
        backgroundColor: "var(--bs-orange)",
        textColor: "var(--bs-orange)",
        bgLight: "rgba(238, 82, 60, 0.1)",
      },
    };
    return colorMap[color] || colorMap.primary;
  };

  const colorStyles = getColorStyles(card.color);

  return (
    <div className="col-lg-4 col-md-6 col-12">
      <div
        className="bg-white rounded-15 shadow-md h-100 overflow-hidden position-relative"
        style={{
          transition: "all 0.3s ease-in-out",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-5px)";
          e.currentTarget.style.boxShadow = "0 8px 25px rgba(0, 0, 0, 0.15)";
          const overlay = e.currentTarget.querySelector(".hover-overlay");
          const button = e.currentTarget.querySelector(".admin-btn");
          const arrow = e.currentTarget.querySelector(".admin-arrow");
          if (overlay) overlay.style.opacity = "1";
          if (button) {
            button.style.backgroundColor = "var(--bs-primary)";
            button.style.color = "var(--bs-white)";
            button.style.borderColor = "var(--bs-primary)";
          }
          if (arrow) arrow.style.transform = "translateX(3px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 1px 6px rgba(62, 96, 147, 0.18)";
          const overlay = e.currentTarget.querySelector(".hover-overlay");
          const button = e.currentTarget.querySelector(".admin-btn");
          const arrow = e.currentTarget.querySelector(".admin-arrow");
          if (overlay) overlay.style.opacity = "0";
          if (button) {
            button.style.backgroundColor = "transparent";
            button.style.color = "var(--bs-primary)";
            button.style.borderColor = "var(--bs-primary)";
          }
          if (arrow) arrow.style.transform = "translateX(0)";
        }}
      >
        {/* Card Header with Icon */}
        <div className="p-4 pb-3">
          <div className="d-flex align-items-center gap-3 mb-3">
            <div
              className="rounded-15 p-3 d-flex align-items-center justify-content-center flex-shrink-0 bg-primary"
              style={{
                width: "50px",
                height: "50px",
              }}
            >
              <span className="material-symbols-outlined text-white fs-md">
                {card.icon}
              </span>
            </div>
            <div className="flex-fill">
              <h4 className="h5 fw-bold mb-1 text-dark">{t(card.title)}</h4>
            </div>
          </div>

          {/* Description */}
          <p className="text-gray-500 fs-sm mb-0" style={{ lineHeight: "1.5" }}>
            {t(card.description)}
          </p>
        </div>

        {/* Card Footer */}
        <div className="p-4 pt-0">
          <Link
            to={card.link}
            className="btn btn-outline-primary btn-sm fw-bold text-decoration-none d-inline-flex align-items-center gap-2 admin-btn"
            style={{ transition: "all 0.3s ease-in-out" }}
          >
            <span>{t(card.linkText)}</span>
            <span
              className="material-symbols-outlined fs-sm admin-arrow"
              style={{ transition: "transform 0.3s ease-in-out" }}
            >
              arrow_forward
            </span>
          </Link>
        </div>

        {/* Hover Effect Background */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100 opacity-0 hover-overlay"
          style={{
            background: colorStyles.bgLight,
            transition: "opacity 0.3s ease-in-out",
            pointerEvents: "none",
          }}
        ></div>
      </div>
    </div>
  );
};

export default AdminCard;
